import { TranslationService } from './services/translation.service';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, APP_INITIALIZER } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { TranslatePipe } from './pipes/translate.pipe';
import { NgxSpinnerModule } from "ngx-spinner";
import { AppComponent } from './app.component';

import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
 
import { ToastrModule } from 'ngx-toastr';
import { MaterialModule } from './material.module';
import { FormsModule } from '@angular/forms';
import { AppConfig } from './app.config';
import { environment } from 'src/environments/environment';
import { SetTokenInterceptorService } from './services/set-token-intercepter.service';
import { DatePipe } from './pipes/date.pipe';
import { YearFormatterPipe } from './pipes/yearformatter.pipe';
import { DateMonthFormatterPipe } from './pipes/datemonthformatter.pipe';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CustomLoader } from './utils/CustomLoader';
import { RootComponent } from './root/root.component';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

export function initializeApp(appConfig: AppConfig) {
  return () => appConfig.load(environment.configFile);
}
@NgModule({
  declarations: [
    TranslatePipe,
    AppComponent,
    DatePipe,
    YearFormatterPipe,
    DateMonthFormatterPipe,
    RootComponent

  ],
  entryComponents: [
  ],
  imports: [
    BrowserModule,
    CommonModule,
    BrowserAnimationsModule,
    FormsModule,
    AppRoutingModule,
    HttpClientModule,
    MaterialModule,
    ScrollingModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        //useClass: CustomLoader,
        deps: [HttpClient]
      }
    }),
    NgxSpinnerModule,
    ToastrModule.forRoot({
      timeOut: 5000
    })
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    TranslationService,
    TranslatePipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SetTokenInterceptorService, multi: true
    },
     AppConfig,
  { provide: APP_INITIALIZER,
    useFactory: initializeApp,
    deps: [AppConfig], multi: true 
   }
   ,
   DatePipe,
   YearFormatterPipe,
   DateMonthFormatterPipe
  ],
  bootstrap: [RootComponent]
})
export class AppModule { }
